import { genderFormat } from '@/utils/formUtils'
import timeutils from 'utils/wt-time-utils'
import { recordTypes, identityCardType, milestoneTypes } from 'json/customer-options'
import { vendorsType } from 'json/mall-options'
import { getEnumeration } from 'enumeration'
export default {
// 获取用户列表数据处理
  getMallUser (data, businessSourceList) {
    data.forEach(item => {
      let businessInformation = item.businessInformation || {}
      item.gender = item.gender && genderFormat(item.gender)
      item.birthday_date = item.birthday && timeutils.format(item.birthday, 'date')
      item.is_registry = item.registry ? '是' : '否'
      item.last_login_time = item.lastLoginTime && timeutils.format(item.lastLoginTime)
      item.invited_time = item.invitationTime && timeutils.format(item.invitationTime, 'date')
      item.sourceName = businessInformation.source && getEnumeration(businessInformation.source, businessSourceList, 'name')
      item.isCPS = item.labels && item.labels.CPS ? '是' : '否'
      item.registry_time = item.registryTime && timeutils.format(item.registryTime)
    })
    return data
  },
  mallUserDetail (data, businessSourceList) {
    let businessInformation = data.businessInformation || {}
    data.sex = data.gender && genderFormat(data.gender)
    data.idCardType = data.identityCardType && getEnumeration(data.identityCardType, identityCardType)
    data.birthday_date = data.birthday && timeutils.format(data.birthday, 'date')
    data.sourceName = businessInformation.source && getEnumeration(businessInformation.source, businessSourceList, 'name')
    data.isCPS = data.labels && data.labels.CPS ? '是' : '否'
    data.is_registry = data.registry ? '是' : '否'
    let shippingAddresses = data.shippingAddresses || []
    shippingAddresses.forEach(item => {
      item.address = (item.provinceName ? item.provinceName : '') + (item.cityName ? item.cityName : '') + (item.districtName ? item.districtName : '') + (item.postAddress ? item.postAddress : '')
    })
    data.registry_time = data.registryTime && timeutils.format(data.registryTime)
    return data
  },
  healthRecords (data) {
    data.forEach(item => {
      item.record_type = item.recordType && getEnumeration(item.recordType, recordTypes)
      item.idCardType = item.identityCardType && getEnumeration(item.identityCardType, identityCardType)
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
    })
    return data
  },
  lifeMilestone (data) {
    data.forEach(item => {
      item.milestone_time = timeutils.format(item.time)
      item.milestone_type = getEnumeration(item.type, milestoneTypes)
    })
    return data
  },
  getHealthRecordDetail (data) {
    data.sex = data.gender && genderFormat(data.gender)
    data.birthday_date = data.birthday && timeutils.format(data.birthday, 'date')
    data.record_type = data.recordType && getEnumeration(data.recordType, recordTypes)
    data.created_date = data.createdDate && timeutils.format(data.createdDate)
    data.idCardType = data.identityCardType && getEnumeration(data.identityCardType, identityCardType)
    return data
  },
  systemCustomerList (data) {
    data.forEach(item => {
      item.base.type = item.base && getEnumeration(item.base.type, vendorsType)
      item.createdDate = timeutils.format(item.createdDate, 'date')
    })
    return data
  },
  getOrganizations (data) {
    data.forEach(item => {
      item.displayName = item.fullName || item.name
    })
    return data
  }
}
